import React from 'react';
import { Form, Input, InputNumber, Modal, Switch } from 'antd';
import type { FormInstance } from 'antd';
import type { LotteryPrize } from '../../types/lottery';
import type { PrizeFormValues } from './detailTypes';

type Props = {
  open: boolean;
  editingPrize: LotteryPrize | null;
  form: FormInstance<PrizeFormValues>;
  onCancel: () => void;
  onOk: () => void;
};

const PrizeModal: React.FC<Props> = ({ open, editingPrize, form, onCancel, onOk }) => (
  <Modal title={editingPrize ? '编辑奖品' : '新增奖品'} open={open} onCancel={onCancel} onOk={onOk} destroyOnClose>
    <Form form={form} layout="vertical" preserve={false}>
      <Form.Item name="name" label="奖品名称" rules={[{ required: true, message: '请输入奖品名称' }]}>
        <Input />
      </Form.Item>
      <Form.Item name="description" label="奖品说明">
        <Input />
      </Form.Item>
      <Form.Item name="isNoPrize" label="未中奖项" valuePropName="checked">
        <Switch checkedChildren="是" unCheckedChildren="否" />
      </Form.Item>
      <Form.Item name="weight" label="概率权重" rules={[{ required: true, message: '请输入权重' }]}>
        <InputNumber min={0} precision={0} style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item name="stock" label="总库存（-1 表示不限量）">
        <InputNumber min={-1} precision={0} style={{ width: '100%' }} />
      </Form.Item>
      {editingPrize && (
        <Form.Item name="remainingStock" label="剩余库存（-1 表示不限量）">
          <InputNumber min={-1} precision={0} style={{ width: '100%' }} />
        </Form.Item>
      )}
      <Form.Item name="sortOrder" label="排序">
        <InputNumber precision={0} style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item name="isActive" label="启用" valuePropName="checked">
        <Switch checkedChildren="启用" unCheckedChildren="停用" />
      </Form.Item>
    </Form>
  </Modal>
);

export default PrizeModal;
